import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import {FormatService} from '../../../../services/format.service';
import {DocumentSummaryItem} from '../../../../model/document-summary-item';
import {LocalizedText} from '../../../../model/localized-text';
import { Bind } from 'primeng/bind';
import { Popover } from 'primeng/popover';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-allowances-detail-summary',
    standalone: true,
    templateUrl: './allowances-detail-summary.component.html',
    styleUrls: ['./allowances-detail-summary.component.css'],
    imports: [Bind, Popover, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllowancesDetailSummaryComponent implements OnInit {
  private formatService = inject(FormatService);


  @Input() summaryItem: DocumentSummaryItem;
  activeDaysDetailIndex = -1;

  ngOnInit() {}

  toggleDaysDetail(index: number): void {
    this.activeDaysDetailIndex = this.activeDaysDetailIndex === index ? -1 : index;
  }

  getCurrency(currency: string): string {
    return this.formatService.formatCurrency(currency);
  }

  getTranslatedData(array: LocalizedText[]): string {
    return this.formatService.getTranslatedData(array);
  }

  getFormattedNumber(result: number | string, fractionDigitNumber?: number): string {
    return this.formatService.formatNumber(result, fractionDigitNumber);
  }
}
